import React, {useState} from "react";
import { useContext } from "react";

const LoaderContext = React.createContext({
  isLoaderEnabled: false,
  setIsLoaderEnabled: () => {},
});


const LoaderProvider = ({children}) => {
  const [isLoaderEnabled, setIsLoaderEnabled] = useState(false);
   
  return <LoaderContext.Provider value={{isLoaderEnabled, setIsLoaderEnabled}}>
    {children}
  </LoaderContext.Provider>
}

const useLoader = () => useContext(LoaderContext);


export { LoaderProvider, useLoader } 